import { component } from 'picoapp';
import loadScript from 'utils/load-script';

export default component(async (node) => {
  const init = async () => {
    await loadScript(`//config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=${node.dataset.appId}`);

    if (window.GorgiasChat) {
      GorgiasChat.init().then(() => {
        node.hidden = true;
        GorgiasChat.open();
      });
    }
  };

  node.addEventListener('click', () => {
    init();
  });
});
